import {FormControl, TextField} from "@mui/material";
import styled from "styled-components";
import {media} from "../../../theme";

export const CreateUserForm = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: 100%;
`;

export const FormGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    width: 100%;

    ${media.md} {
        grid-template-columns: 1fr 1fr;
    }
`;

export const FullRow = styled.div`
    grid-column: 1 / -1;
    width: 100%;
`;

export const ActionsRow = styled(FullRow)`
    display: flex;
    justify-content: flex-end;
`;

export const StyledTextField = styled(TextField)`
    width: 100%;
    max-width: none;
`;

export const StyledFormControl = styled(FormControl)`
    width: 100%;
    max-width: none;
`;
